import { ColorConversion } from "./ColorConversion";
import { GBKEncoder } from "./GBKEncoder";
import { UtilsGMCookie } from "./UtilsGMCookie";
import { AjaxHooker } from "./ajaxHooker/ajaxHooker.js";
import { AjaxHooker1_2_4 } from "./ajaxHooker/ajaxHooker1.2.4";
import { GMMenu } from "./UtilsGMMenu";
import { Hooks } from "./Hooks";
import { Httpx } from "./Httpx";
import { indexedDB } from "./indexedDB";
import { LockFunction } from "./LockFunction";
import { Log } from "./Log";
import { Progress } from "./Progress";
import { TryCatch } from "./TryCatch";
import { UtilsDictionary } from "./Dictionary";
import { GenerateUUID } from "./UtilsCommon";
import { WindowApi } from "./WindowApi";
import { Vue } from "./Vue";
import { ModuleRaid } from "./ModuleRaid";
class Utils {
    windowApi;
    constructor(option) {
        this.windowApi = new WindowApi(option);
    }
    /** 版本号 */
    version = "2025.4.11";
    addStyle(cssText) {
        if (typeof cssText !== "string") {
            throw new Error("Utils.addStyle 参数cssText 必须为String类型");
        }
        let cssNode = this.windowApi.document.createElement("style");
        cssNode.setAttribute("type", "text/css");
        cssNode.innerHTML = cssText;
        if (this.windowApi.document.head) {
            /* 插入head最后 */
            this.windowApi.document.head.appendChild(cssNode);
        }
        else if (this.windowApi.document.body) {
            /* 插入body后 */
            this.windowApi.document.body.appendChild(cssNode);
        }
        else if (this.windowApi.document.documentElement.childNodes.length === 0) {
            /* 插入#html第一个元素后 */
            this.windowApi.document.documentElement.appendChild(cssNode);
        }
        else {
            /* 插入head前面 */
            this.windowApi.document.documentElement.insertBefore(cssNode, this.windowApi.document.documentElement.childNodes[0]);
        }
        return cssNode;
    }
    assign(target = {}, source = {}, isAdd = false) {
        let UtilsContext = this;
        if (Array.isArray(source)) {
            let canTraverse = source.filter((item) => {
                return typeof item === "object";
            });
            if (!canTraverse.length) {
                return source;
            }
        }
        if (source == null) {
            return target;
        }
        if (target == null) {
            target = {};
        }
        if (isAdd) {
            for (const sourceKeyName in source) {
                const targetKeyName = sourceKeyName;
                let targetValue = target[targetKeyName];
                let sourceValue = source[sourceKeyName];
                if (typeof sourceValue === "object" &&
                    sourceValue != null &&
                    sourceKeyName in target &&
                    !UtilsContext.isDOM(sourceValue)) {
                    /* 源端的值是object类型，且不是元素节点 */
                    target[sourceKeyName] = UtilsContext.assign(targetValue, sourceValue, isAdd);
                    continue;
                }
                target[sourceKeyName] = sourceValue;
            }
        }
        else {
            for (const targetKeyName in target) {
                if (targetKeyName in source) {
                    let targetValue = target[targetKeyName];
                    let sourceValue = source[targetKeyName];
                    if (typeof sourceValue === "object" &&
                        sourceValue != null &&
                        !UtilsContext.isDOM(sourceValue) &&
                        Object.keys(sourceValue).length) {
                        /* 源端的值是object类型，且不是元素节点 */
                        target[targetKeyName] = UtilsContext.assign(targetValue, sourceValue, isAdd);
                        continue;
                    }
                    /* 直接赋值 */
                    target[targetKeyName] = sourceValue;
                }
            }
        }
        return target;
    }
    async asyncReplaceAll(string, pattern, asyncFn) {
        let UtilsContext = this;
        if (typeof string !== "string") {
            throw new TypeError("string必须是字符串");
        }
        if (typeof asyncFn !== "function") {
            throw new TypeError("asyncFn必须是函数");
        }
        let reg;
        if (typeof pattern === "string") {
            reg = new RegExp(UtilsContext.parseStringToRegExpString(pattern), "g");
        }
        else if (pattern instanceof RegExp) {
            if (!pattern.global) {
                throw new TypeError("pattern必须是全局匹配");
            }
            reg = new RegExp(pattern);
        }
        else {
            throw new TypeError("pattern必须是正则对象");
        }
        let result = [];
        let match;
        let lastIndex = 0;
        while ((match = reg.exec(string)) !== null) {
            /* 异步获取匹配对应的字符串 */
            const item = asyncFn(match[0]);
            /* 获取该匹配项和上一个匹配项的中间的字符串 */
            const prefix = string.slice(lastIndex, match.index);
            lastIndex = match.index + match[0].length;
            result.push(item);
            result.push(prefix);
        }
        result.push(string.slice(lastIndex));
        /* 等待所有异步完成 */
        result = await Promise.all(result);
        return result.join("");
    }
    /**
     * ajax劫持库，支持xhr和fetch劫持。
     * + 来源：https://bbs.tampermonkey.net.cn/thread-3284-1-1.html
     * + 作者：cxxjackie
     * + 版本：1.4.4
     * + 旧版本：1.2.4
     * + 文档：https://scriptcat.org/zh-CN/script-show-page/637/
     * @param useOldVersion 是否使用旧版本，默认false
     */
    ajaxHooker = (useOldVersion = false) => {
        if (useOldVersion) {
            return AjaxHooker1_2_4();
        }
        else {
            return AjaxHooker();
        }
    };
    canvasClickByPosition(canvasElement, clientX = 0, clientY = 0, view = globalThis) {
        if (!(canvasElement instanceof HTMLCanvasElement)) {
            throw new Error("Utils.canvasClickByPosition 参数canvasElement必须是canvas元素");
        }
        clientX = parseInt(clientX.toString());
        clientY = parseInt(clientY.toString());
        const eventInit = {
            cancelBubble: true,
            cancelable: true,
            clientX: clientX,
            clientY: clientY,
            // @ts-ignore
            view: view,
            detail: 1,
        };
        canvasElement.dispatchEvent(new MouseEvent("mousedown", eventInit));
        canvasElement.dispatchEvent(new MouseEvent("mouseup", eventInit));
    }
    checkUserClickInNode(element) {
        let UtilsContext = this;
        if (!UtilsContext.isDOM(element)) {
            throw new Error("Utils.checkUserClickInNode 参数 targetNode 必须为 Element|Node 类型");
        }
        let clickEvent = UtilsContext.windowApi.window.event;
        let touchEvent = UtilsContext.windowApi.window.event;
        let $click = clickEvent?.composedPath()?.[0];
        // 点击的x坐标
        let clickPosX = clickEvent?.clientX != null
            ? clickEvent.clientX
            : touchEvent.touches[0].clientX;
        // 点击的y坐标
        let clickPosY = clickEvent?.clientY != null
            ? clickEvent.clientY
            : touchEvent.touches[0].clientY;
        let { 
        /* 要检测的元素的相对屏幕的横坐标最左边 */
        left: elementPosXLeft, 
        /* 要检测的元素的相对屏幕的横坐标最右边 */
        right: elementPosXRight, 
        /* 要检测的元素的相对屏幕的纵坐标最上边 */
        top: elementPosYTop, 
        /* 要检测的元素的相对屏幕的纵坐标最下边 */
        bottom: elementPosYBottom, } = element.getBoundingClientRect();
        if (clickPosX >= elementPosXLeft &&
            clickPosX <= elementPosXRight &&
            clickPosY >= elementPosYTop &&
            clickPosY <= elementPosYBottom) {
            return true;
        }
        else if (($click && element.contains($click)) || $click == element) {
            /* 这种情况是应对在界面中隐藏的元素，getBoundingClientRect获取的都是0 */
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * 复制formData数据
     * @param formData 需要clone的数据
     */
    cloneFormData(formData, filterFn) {
        let clonedFormData = new FormData();
        for (let [key, value] of formData.entries()) {
            let isFilter = typeof filterFn === "function" ? filterFn(key, value) : false;
            if (typeof isFilter === "boolean" && isFilter) {
                continue;
            }
            clonedFormData.append(key, value);
        }
        return clonedFormData;
    }
    createOverload() {
        let fnMap = new Map();
        function overload(...args) {
            let key = args.map((it) => typeof it).join(",");
            let fn = fnMap.get(key);
            if (!fn) {
                throw new TypeError("没有找到对应的实现");
            }
            return fn.apply(this, args);
        }
        overload.addImpl = function (...args) {
            let fn = args.pop();
            if (typeof fn !== "function") {
                throw new TypeError("最后一个参数必须是函数");
            }
            let key = args.join(",");
            fnMap.set(key, fn);
        };
        return overload;
    }
    /**
     * 颜色转换
     * @returns
     */
    ColorConversion = ColorConversion;
    deepClone(obj) {
        let UtilsContext = this;
        if (obj === void 0)
            return void 0;
        if (obj === null)
            return null;
        let clone = obj instanceof Array ? [] : {};
        for (const [key, value] of Object.entries(obj)) {
            clone[key] =
                typeof value === "object" ? UtilsContext.deepClone(value) : value;
        }
        return clone;
    }
    debounce(fn, delay = 0) {
        let timer = null;
        const context = this;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    }
    deleteParentNode(element, targetSelector) {
        let UtilsContext = this;
        if (element == null) {
            return;
        }
        if (!UtilsContext.isDOM(element)) {
            throw new Error("Utils.deleteParentNode 参数 target 必须为 Node|HTMLElement 类型");
        }
        if (typeof targetSelector !== "string") {
            throw new Error("Utils.deleteParentNode 参数 targetSelector 必须为 string 类型");
        }
        let result = false;
        let needRemoveDOM = element.closest(targetSelector);
        if (needRemoveDOM) {
            needRemoveDOM.remove();
            result = true;
        }
        return result;
    }
    /**
     * 字典
     * @example
     * let dictionary = new Utils.Dictionary();
     * let dictionary2 = new Utils.Dictionary();
     * dictionary.set("test","111");
     * dictionary.get("test");
     * > '111'
     * dictionary.has("test");
     * > true
     * dictionary.concat(dictionary2);
     **/
    Dictionary = UtilsDictionary;
    dispatchEvent(element, eventName, details) {
        let eventNameList = [];
        if (typeof eventName === "string") {
            eventNameList = [eventName];
        }
        if (Array.isArray(eventName)) {
            eventNameList = [...eventName];
        }
        eventNameList.forEach((_eventName_) => {
            let event = new Event(_eventName_);
            if (details) {
                Object.assign(event, details);
            }
            element.dispatchEvent(event);
        });
    }
    downloadBase64(base64Data, fileName, isIFrame = false) {
        if (typeof base64Data !== "string") {
            throw new Error("Utils.downloadBase64 参数 base64Data 必须为 string 类型");
        }
        if (typeof fileName !== "string") {
            throw new Error("Utils.downloadBase64 参数 fileName 必须为 string 类型");
        }
        if (isIFrame) {
            /* 使用iframe */
            const iframeElement = this.windowApi.document.createElement("iframe");
            iframeElement.style.display = "none";
            iframeElement.src = base64Data;
            this.windowApi.document.body.appendChild(iframeElement);
            setTimeout(() => {
                iframeElement.contentWindow.document.execCommand("SaveAs", true, fileName);
                this.windowApi.document.body.removeChild(iframeElement);
            }, 100);
        }
        else {
            /* 使用A标签 */
            const linkElement = this.windowApi.document.createElement("a");
            linkElement.setAttribute("target", "_blank");
            linkElement.download = fileName;
            linkElement.href = base64Data;
            linkElement.click();
        }
    }
    findWebPageVisibleText(str = "", caseSensitive = false) {
        let TRange = null;
        let strFound;
        if (this.windowApi.globalThis.find) {
            /* CODE FOR BROWSERS THAT SUPPORT window.find */
            let windowFind = this.windowApi.self.find;
            strFound = windowFind(str, caseSensitive, true, true, false);
            if (strFound &&
                this.windowApi.self.getSelection &&
                !this.windowApi.self.getSelection().anchorNode) {
                strFound = windowFind(str, caseSensitive, true, true, false);
            }
            if (!strFound) {
                strFound = windowFind(str, 0, 1);
                while (windowFind(str, 0, 1))
                    continue;
            }
        }
        else if (navigator.appName.indexOf("Microsoft") != -1) {
            /* EXPLORER-SPECIFIC CODE */
            if (TRange != null) {
                TRange = TRange;
                TRange.collapse(false);
                strFound = TRange.findText(str);
                if (strFound)
                    TRange.select();
            }
            if (TRange == null || strFound == 0) {
                TRange = this.windowApi.self.document.body.createTextRange();
                strFound = TRange.findText(str);
                if (strFound)
                    TRange.select();
            }
        }
        else if (navigator.appName == "Opera") {
            alert("Opera browsers not supported, sorry...");
            return;
        }
        return strFound ? true : false;
    }
    *findElementsWithText(element, text, filter) {
        let that = this;
        if (element.outerHTML.includes(text)) {
            if (element.children.length === 0) {
                let filterResult = typeof filter === "function" ? filter(element) : false;
                if (!filterResult) {
                    yield element;
                }
            }
            else {
                let textElement = Array.from(element.childNodes).filter((ele) => ele.nodeType === Node.TEXT_NODE);
                for (let ele of textElement) {
                    if (ele.textContent.includes(text)) {
                        let filterResult = typeof filter === "function" ? filter(element) : false;
                        if (!filterResult) {
                            yield ele;
                        }
                    }
                }
            }
        }
        for (let index = 0; index < element.children.length; index++) {
            let childElement = element.children[index];
            yield* that.findElementsWithText(childElement, text, filter);
        }
    }
    /**
     * 判断该元素是否可见，如果不可见，向上找它的父元素直至找到可见的元素
     * @param element
     * @example
     * let visibleElement = Utils.findVisibleElement(document.querySelector("a.xx"));
     * > <HTMLElement>
     */
    findVisibleElement(element) {
        let currentElement = element;
        while (currentElement) {
            let elementRect = currentElement.getBoundingClientRect();
            if (Boolean(elementRect.length)) {
                return currentElement;
            }
            currentElement = currentElement.parentElement;
        }
        return null;
    }
    formatByteToSize(byteSize, addType = true) {
        byteSize = parseInt(byteSize.toString());
        if (isNaN(byteSize)) {
            throw new Error("Utils.formatByteToSize 参数 byteSize 格式不正确");
        }
        let result = 0;
        let resultType = "KB";
        let sizeData = {};
        sizeData.B = 1;
        sizeData.KB = 1024;
        sizeData.MB = sizeData.KB * sizeData.KB;
        sizeData.GB = sizeData.MB * sizeData.KB;
        sizeData.TB = sizeData.GB * sizeData.KB;
        sizeData.PB = sizeData.TB * sizeData.KB;
        sizeData.EB = sizeData.PB * sizeData.KB;
        sizeData.ZB = sizeData.EB * sizeData.KB;
        sizeData.YB = sizeData.ZB * sizeData.KB;
        sizeData.BB = sizeData.YB * sizeData.KB;
        sizeData.NB = sizeData.BB * sizeData.KB;
        sizeData.DB = sizeData.NB * sizeData.KB;
        for (let key in sizeData) {
            result = byteSize / sizeData[key];
            resultType = key;
            if (sizeData.KB >= result) {
                break;
            }
        }
        result = result.toFixed(2);
        result = addType
            ? result + resultType.toString()
            : parseFloat(result.toString());
        return result;
    }
    getNodeListValue(...args) {
        let resultArray = [];
        for (let arg of args) {
            let value = arg;
            if (typeof arg === "function") {
                /* 方法 */
                value = arg();
            }
            if (value.length !== 0) {
                resultArray = [...value];
                break;
            }
        }
        return resultArray;
    }
    getNonNullValue(...args) {
        let resultValue = args[args.length - 1];
        let UtilsContext = this;
        for (const argValue of args) {
            if (UtilsContext.isNotNull(argValue)) {
                resultValue = argValue;
                break;
            }
        }
        return resultValue;
    }
    formatTime(text = new Date(), formatType = "yyyy-MM-dd HH:mm:ss") {
        let time = text == null ? new Date() : new Date(text);
        /**
         * 校验时间补0
         * @param timeNum
         * @returns
         */
        function checkTime(timeNum) {
            if (timeNum < 10)
                return "0" + timeNum;
            return timeNum;
        }
        /**
         * 时间制修改 24小时制转12小时制
         * @param hourNum 小时
         * @returns
         */
        function timeSystemChange(hourNum) {
            return hourNum > 12 ? hourNum - 12 : hourNum;
        }
        let timeRegexp = {
            yyyy: time.getFullYear(),
            /* 年 */
            MM: checkTime(time.getMonth() + 1),
            /* 月 */
            dd: checkTime(time.getDate()),
            /* 日 */
            HH: checkTime(time.getHours()),
            /* 时 (24小时制) */
            hh: checkTime(timeSystemChange(time.getHours())),
            /* 时 (12小时制) */
            mm: checkTime(time.getMinutes()),
            /* 分 */
            ss: checkTime(time.getSeconds()),
            /* 秒 */
        };
        Object.keys(timeRegexp).forEach(function (key) {
            let replaecRegexp = new RegExp(key, "g");
            formatType = formatType.replace(replaecRegexp, timeRegexp[key]);
        });
        return formatType;
    }
    formatToTimeStamp(text) {
        /* 把字符串格式的时间（完整，包括日期和时间）格式化成时间 */
        if (typeof text !== "string") {
            throw new Error("Utils.formatToTimeStamp 参数 text 必须为 string 类型");
        }
        if (text.length === 8) {
            /* 该字符串只有时分秒 */
            let today = new Date();
            text =
                today.getFullYear() +
                    "-" +
                    (today.getMonth() + 1) +
                    "-" +
                    today.getDate() +
                    " " +
                    text;
        }
        text = text.substring(0, 19);
        text = text.replace(/-/g, "/");
        let timestamp = new Date(text).getTime();
        return timestamp;
    }
    /**
     * gbk格式的url编码,来自https://greasyfork.org/zh-CN/scripts/427726-gbk-url-js
     * @example
     * let gbkEncoder = new Utils.GBKEncoder();
     * gbkEncoder.encode("测试");
     * > '%B2%E2%CA%D4'
     * gbkEncoder.decode("%B2%E2%CA%D4");
     * > 测试
     */
    GBKEncoder = GBKEncoder;
    /**
     * 获取 transitionend 的在各个浏览器的兼容名
     */
    getTransitionEndNameList() {
        return [
            "webkitTransitionEnd",
            "mozTransitionEnd",
            "MSTransitionEnd",
            "otransitionend",
            "transitionend",
        ];
    }
    /**
     * 获取 animationend 的在各个浏览器的兼容名
     */
    getAnimationEndNameList() {
        return [
            "webkitAnimationEnd",
            "mozAnimationEnd",
            "MSAnimationEnd",
            "oanimationend",
            "animationend",
        ];
    }
    getArrayLastValue(targetObj) {
        return targetObj[targetObj.length - 1];
    }
    getArrayRealValue(...args) {
        let result = null;
        for (let arg of args) {
            if (typeof arg === "function") {
                /* 方法 */
                arg = arg();
            }
            if (arg != null) {
                result = arg;
                break;
            }
        }
        return result;
    }
    getDaysDifference(timestamp1 = Date.now(), timestamp2 = Date.now(), type = "天") {
        type = type.trim();
        if (timestamp1.toString().length === 10) {
            timestamp1 = timestamp1 * 1000;
        }
        if (timestamp2.toString().length === 10) {
            timestamp2 = timestamp2 * 1000;
        }
        let smallTimeStamp = timestamp1 > timestamp2 ? timestamp2 : timestamp1;
        let bigTimeStamp = timestamp1 > timestamp2 ? timestamp1 : timestamp2;
        let oneSecond = 1000; /* 一秒的毫秒数 */
        let oneMinute = 60 * oneSecond; /* 一分钟的毫秒数 */
        let oneHour = 60 * oneMinute; /* 一小时的毫秒数 */
        let oneDay = 24 * oneHour; /* 一天的毫秒数 */
        let oneMonth = 30 * oneDay; /* 一个月的毫秒数(30天) */
        let oneYear = 12 * oneMonth; /* 一年的毫秒数 */
        let bigDate = new Date(bigTimeStamp);
        let smallDate = new Date(smallTimeStamp);
        let remainderValue = 1;
        if (type === "年") {
            remainderValue = oneYear;
        }
        else if (type === "月") {
            remainderValue = oneMonth;
        }
        else if (type === "天") {
            remainderValue = oneDay;
        }
        else if (type === "时") {
            remainderValue = oneHour;
        }
        else if (type === "分") {
            remainderValue = oneMinute;
        }
        else if (type === "秒") {
            remainderValue = oneSecond;
        }
        let diffValue = Math.round(Math.abs((bigDate - smallDate) / remainderValue));
        if (type === "auto") {
            let timeDifference = bigTimeStamp - smallTimeStamp;
            diffValue = Math.floor(timeDifference / (24 * 3600 * 1000));
            if (diffValue > 0) {
                diffValue = diffValue + "天";
            }
            else {
                /* 计算出小时数 */
                let leave1 = timeDifference % (24 * 3600 * 1000); /* 计算天数后剩余的毫秒数 */
                let hours = Math.floor(leave1 / (3600 * 1000));
                if (hours > 0) {
                    diffValue = hours + "小时";
                }
                else {
                    /* 计算相差分钟数 */
                    let leave2 = leave1 % (3600 * 1000); /* 计算小时数后剩余的毫秒数 */
                    let minutes = Math.floor(leave2 / (60 * 1000));
                    if (minutes > 0) {
                        diffValue = minutes + "分钟";
                    }
                    else {
                        /* 计算相差秒数 */
                        let leave3 = leave2 % (60 * 1000); /* 计算分钟数后剩余的毫秒数 */
                        let seconds = Math.round(leave3 / 1000);
                        diffValue = seconds + "秒";
                    }
                }
            }
        }
        return diffValue;
    }
    getElementSelector(element) {
        let UtilsContext = this;
        // @ts-ignore
        if (!element)
            return;
        // @ts-ignore
        if (!element.parentElement)
            return;
        /* 如果元素有id属性，则直接返回id选择器 */
        if (element.id)
            return "#" + element.id;
        /* 递归地获取父元素的选择器 */
        let selector = UtilsContext.getElementSelector(element.parentElement);
        if (!selector) {
            return element.tagName.toLowerCase();
        }
        /* 如果有多个相同类型的兄弟元素，则需要添加索引 */
        if (element.parentElement.querySelectorAll(element.tagName).length > 1) {
            let index = Array.prototype.indexOf.call(element.parentElement.children, element) +
                1;
            selector +=
                " > " + element.tagName.toLowerCase() + ":nth-child(" + index + ")";
        }
        else {
            selector += " > " + element.tagName.toLowerCase();
        }
        return selector;
    }
    /**
     * 获取最大值
     * @example
     * Utils.getMaxValue([{1:123},{2:345},{3:456}],(index,value)=>{return parseInt(index)})
     * > 2
     */
    getMaxValue(...args) {
        let result = [...args];
        let newResult = [];
        if (result.length === 0) {
            // @ts-ignore
            return;
        }
        if (result.length > 1) {
            if (result.length === 2 &&
                typeof result[0] === "object" &&
                typeof result[1] === "function") {
                let data = result[0];
                let handleDataFunc = result[1];
                Object.keys(data).forEach((keyName) => {
                    newResult = [...newResult, handleDataFunc(keyName, data[keyName])];
                });
            }
            else {
                result.forEach((item) => {
                    if (!isNaN(parseFloat(item))) {
                        newResult = [...newResult, parseFloat(item)];
                    }
                });
            }
            return Math.max(...newResult);
        }
        else {
            result[0].forEach((item) => {
                if (!isNaN(parseFloat(item))) {
                    newResult = [...newResult, parseFloat(item)];
                }
            });
            return Math.max(...newResult);
        }
    }
    getMaxZIndexNodeInfo(deviation = 1, target = this.windowApi.document, ignoreCallBack) {
        deviation = Number.isNaN(deviation) ? 1 : deviation;
        const UtilsContext = this;
        // 最大值 2147483647
        // const maxZIndex = Math.pow(2, 31) - 1;
        // 比较值 2000000000
        const maxZIndexCompare = 2 * Math.pow(10, 9);
        // 当前页面最大的z-index
        let zIndex = 0;
        // 当前的最大z-index的元素，调试使用
        // @ts-ignore
        let maxZIndexNode = null;
        /**
         * 元素是否可见
         * @param $css
         */
        function isVisibleNode($css) {
            return $css.position !== "static" && $css.display !== "none";
        }
        /**
         * 查询元素的z-index
         * 并比较值是否是已获取的最大值
         * @param $ele
         */
        function queryMaxZIndex($ele) {
            if (typeof ignoreCallBack === "function") {
                let ignoreResult = ignoreCallBack($ele);
                if (typeof ignoreResult === "boolean" && !ignoreResult) {
                    return;
                }
            }
            /** 元素的样式 */
            const nodeStyle = UtilsContext.windowApi.window.getComputedStyle($ele);
            /* 不对position为static和display为none的元素进行获取它们的z-index */
            if (isVisibleNode(nodeStyle)) {
                let nodeZIndex = parseInt(nodeStyle.zIndex);
                if (!isNaN(nodeZIndex)) {
                    if (nodeZIndex > zIndex) {
                        // 赋值到全局
                        zIndex = nodeZIndex;
                        maxZIndexNode = $ele;
                    }
                }
                // 判断shadowRoot
                if ($ele.shadowRoot != null && $ele instanceof ShadowRoot) {
                    $ele.shadowRoot.querySelectorAll("*").forEach(($shadowEle) => {
                        queryMaxZIndex($shadowEle);
                    });
                }
            }
        }
        target.querySelectorAll("*").forEach(($ele, index) => {
            queryMaxZIndex($ele);
        });
        zIndex += deviation;
        if (zIndex >= maxZIndexCompare) {
            // 最好不要超过最大值
            zIndex = maxZIndexCompare;
        }
        return {
            node: maxZIndexNode,
            zIndex: zIndex,
        };
    }
    getMaxZIndex(deviation = 1, target = this.windowApi.document, ignoreCallBack) {
        return this.getMaxZIndexNodeInfo(deviation, target, ignoreCallBack).zIndex;
    }
    getMinValue(...args) {
        let result = [...args];
        let newResult = [];
        if (result.length === 0) {
            // @ts-ignore
            return;
        }
        if (result.length > 1) {
            if (result.length === 2 &&
                typeof result[0] === "object" &&
                typeof result[1] === "function") {
                let data = result[0];
                let handleDataFunc = result[1];
                Object.keys(data).forEach((keyName) => {
                    newResult = [...newResult, handleDataFunc(keyName, data[keyName])];
                });
            }
            else {
                result.forEach((item) => {
                    if (!isNaN(parseFloat(item))) {
                        newResult = [...newResult, parseFloat(item)];
                    }
                });
            }
            return Math.min(...newResult);
        }
        else {
            result[0].forEach((item) => {
                if (!isNaN(parseFloat(item))) {
                    newResult = [...newResult, parseFloat(item)];
                }
            });
            return Math.min(...newResult);
        }
    }
    /**
     * 获取随机的安卓手机User-Agent
     * @example
     * Utils.getRandomAndroidUA();
     * > 'Mozilla/5.0 (Linux; Android 10; MI 13 Build/OPR1.170623.027; wv) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/103.0.3490.40 Mobile Safari/537.36'
     **/
    getRandomAndroidUA() {
        let UtilsContext = this;
        let mobileNameList = [
            "LDN-LX3",
            "RNE-L03",
            "ASUS_X00ID Build/NMF26F",
            "WAS-LX3",
            "PRA-LX3",
            "MYA-L03",
            "Moto G Play",
            "Moto C Build/NRD90M.063",
            "Redmi Note 4 Build/NRD90M",
            "HUAWEI VNS-L21 Build/HUAWEIVNS-L21",
            "VTR-L09",
            "TRT-LX3",
            "M2003J15SC Build/RP1A.200720.011; wv",
            "MI 13 Build/OPR1.170623.027; wv",
        ];
        /* 安卓版本 */
        let androidVersion = UtilsContext.getRandomValue(12, 14);
        /* 手机型号 */
        let randomMobile = UtilsContext.getRandomValue(mobileNameList);
        /* chrome大版本号 */
        let chromeVersion1 = UtilsContext.getRandomValue(120, 132);
        let chromeVersion2 = UtilsContext.getRandomValue(0, 0);
        let chromeVersion3 = UtilsContext.getRandomValue(2272, 6099);
        let chromeVersion4 = UtilsContext.getRandomValue(1, 218);
        return `Mozilla/5.0 (Linux; Android ${androidVersion}; ${randomMobile}) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/${chromeVersion1}.${chromeVersion2}.${chromeVersion3}.${chromeVersion4} Mobile Safari/537.36`;
    }
    /**
     * 获取随机的电脑端User-Agent
     * + Mozilla/5.0：以前用于Netscape浏览器，目前大多数浏览器UA都会带有
     * + Windows NT 13：代表Window11系统
     * + Windows NT 10.0：代表Window10系统
     * + Windows NT 6.1：代表windows7系统
     * + WOW64：Windows-on-Windows 64-bit，32位的应用程序运行于此64位处理器上
     * + Win64：64位
     * + AppleWebKit/537.36：浏览器内核
     * + KHTML：HTML排版引擎
     * + like Gecko：这不是Geckeo 浏览器，但是运行起来像Geckeo浏览器
     * + Chrome/106.0.5068.19：Chrome版本号
     * + Safari/537.36：宣称自己是Safari？
     * @returns 返回随机字符串
     * @example
     * Utils.getRandomPCUA();
     * > 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/106.0.5068.19 Safari/537.36'
     **/
    getRandomPCUA() {
        let UtilsContext = this;
        /* chrome大版本号 */
        let chromeVersion1 = UtilsContext.getRandomValue(120, 132);
        let chromeVersion2 = UtilsContext.getRandomValue(0, 0);
        let chromeVersion3 = UtilsContext.getRandomValue(2272, 6099);
        let chromeVersion4 = UtilsContext.getRandomValue(1, 218);
        return `Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/${chromeVersion1}.${chromeVersion2}.${chromeVersion3}.${chromeVersion4} Safari/537.36`;
    }
    getRandomValue(...args) {
        let result = [...args];
        if (result.length > 1) {
            if (result.length === 2 &&
                typeof result[0] === "number" &&
                typeof result[1] === "number") {
                let leftNumber = result[0] > result[1] ? result[1] : result[0];
                let rightNumber = result[0] > result[1] ? result[0] : result[1];
                return (Math.round(Math.random() * (rightNumber - leftNumber)) + leftNumber);
            }
            else {
                return result[Math.floor(Math.random() * result.length)];
            }
        }
        else if (result.length === 1) {
            let paramData = result[0];
            if (Array.isArray(paramData)) {
                return paramData[Math.floor(Math.random() * paramData.length)];
            }
            else if (typeof paramData === "object" &&
                Object.keys(paramData).length > 0) {
                let paramObjDataKey = Object.keys(paramData)[Math.floor(Math.random() * Object.keys(paramData).length)];
                return paramData[paramObjDataKey];
            }
            else {
                return paramData;
            }
        }
    }
    /**
     * 获取元素上的使用React框架的实例属性，目前包括reactFiber、reactProps、reactEvents、reactEventHandlers、reactInternalInstance
     * @param element 需要获取的目标元素
     * @returns
     * @example
     * Utils.getReactObj(document.querySelector("input"))?.reactProps?.onChange({target:{value:"123"}});
     */
    getReactObj(element) {
        let result = {};
        Object.keys(element).forEach((domPropsName) => {
            if (domPropsName.startsWith("__react")) {
                let propsName = domPropsName.replace(/__(.+)\$.+/i, "$1");
                if (propsName in result) {
                    new Error("重复属性 " + domPropsName);
                }
                else {
                    result[propsName] = element[domPropsName];
                }
            }
        });
        return result;
    }
    /**
     * 获取对象上的Symbol属性，如果没设置keyName，那么返回一个对象，对象是所有遍历到的Symbol对象
     * @param target 目标对象
     * @param keyName （可选）Symbol名或者Symbol对象
     */
    getSymbol(target, keyName) {
        if (typeof target !== "object") {
            throw new TypeError("target不是一个对象");
        }
        let objectsSymbols = Object.getOwnPropertySymbols(target);
        if (typeof keyName === "string") {
            let findSymbol = objectsSymbols.find((key) => {
                return key.toString() === keyName;
            });
            if (findSymbol) {
                return target[findSymbol];
            }
        }
        else if (typeof keyName === "symbol") {
            let findSymbol = objectsSymbols.find((key) => {
                return key === keyName;
            });
            if (findSymbol) {
                return target[findSymbol];
            }
        }
        else {
            let result = {};
            objectsSymbols.forEach((item) => {
                result[item] = target[item];
            });
            return result;
        }
    }
    /**
     * 获取文本的字符长度
     * @param text
     * @example
     * Utils.getTextLength("测试文本")
     * > 12
     */
    getTextLength(text) {
        let encoder = new TextEncoder();
        let bytes = encoder.encode(text);
        return bytes.length;
    }
    getTextStorageSize(text, addType = true) {
        let UtilsContext = this;
        return UtilsContext.formatByteToSize(UtilsContext.getTextLength(text), addType);
    }
    getThunderUrl(url) {
        if (url == null) {
            throw new TypeError("url不能为空");
        }
        if (typeof url !== "string") {
            throw new TypeError("url必须是string类型");
        }
        if (url.trim() === "") {
            throw new TypeError("url不能为空字符串或纯空格");
        }
        return `thunder://${this.windowApi.globalThis.btoa("AA" + url + "ZZ")}`;
    }
    /**
     * 对于GM_cookie的兼容写法，当无法使用GM_cookie时可以使用这个,但是并不完全兼容，有些写不出来且限制了httponly是无法访问的
     * @example
      let GM_cookie = new Utils.GM_Cookie();
      GM_cookie.list({name:"xxx_cookie_xxx"},function(cookies,error){
          if (!error) {
              console.log(cookies);
              console.log(cookies.value);
          } else {
              console.error(error);
          }
      });
      GM_cookie.set({name:"xxx_cookie_test_xxx",value:"这是Cookie测试值"},function(error){
          if (error) {
              console.error(error);
          } else {
              console.log('Cookie set successfully.');
          }
      })
      GM_cookie.delete({name:"xxx_cookie_test_xxx"},function(error){
          if (error) {
              console.error(error);
          } else {
              console.log('Cookie set successfully.');
          }
      })
     **/
    GM_Cookie = UtilsGMCookie;
    /**
     * 注册油猴菜单，要求本地存储的键名不能存在其它键名`GM_Menu_Local_Map`会冲突/覆盖
     * @example
      let GM_Menu = new Utils.GM_Menu({
        data: [
          {
            menu_key: "menu_key",
            text: "测试按钮",
            enable: true,
            accessKey: "a",
            autoClose: false,
            showText(text, enable) {
              return "[" + (enable ? "√" : "×") + "]" + text;
            },
            callback(data) {
              console.log("点击菜单，值修改为", data.enable);
            },
          },
        ],
        autoReload: false,
        GM_getValue,
        GM_setValue,
        GM_registerMenuCommand,
        GM_unregisterMenuCommand,
      });
  
  
      // 获取某个菜单项的值
      GM_Menu.get("menu_key");
      > true
  
      // 获取某个菜单项的开启/关闭后显示的文本
      GM_Menu.getShowTextValue("menu_key");
      > √测试按钮
  
      // 添加键为menu_key2的菜单项
      GM_Menu.add({
        key:"menu_key2",
        text: "测试按钮2",
        enable: false,
        showText(text,enable){
          return "[" + (enable ? "√" : "×") + "]" + text;
        },
        callback(data){
          console.log("点击菜单，值修改为",data.enable);
        }
      });
      // 使用数组的方式添加多个菜单，如menu_key3、menu_key4
      GM_Menu.add([
        {
          key:"menu_key3",
          text: "测试按钮3",
          enable: false,
          showText(text,enable){
            return "[" + (enable ? "√" : "×") + "]" + text;
          },
          callback(data){
            console.log("点击菜单，值修改为",data.enable);
          }
        },
        {
          key:"menu_key4",
          text: "测试按钮4",
          enable: false,
          showText(text,enable){
            return "[" + (enable ? "√" : "×") + "]" + text;
          },
          callback(data){
            console.log("点击菜单，值修改为",data.enable);
          }
        }
      ]);
  
      // 更新键为menu_key的显示文字和点击回调
      GM_Menu.update({
        menu_key:{
          text: "更新后的测试按钮",
          enable: true,
          showText(text,enable){
            return "[" + (enable ? "√" : "×") + "]" + text;
          },
          callback(data){
            console.log("点击菜单更新后的测试按钮，新值修改为",data.enable);
          }
        }
      });
  
      // 删除键为menu_key的菜单
      GM_Menu.delete("menu_key");
     **/
    GM_Menu = GMMenu;
    /**
     * 基于Function prototype，能够勾住和释放任何函数
     *
     * .hook
     * + realFunc {string} 用于保存原始函数的函数名称,用于unHook
     * + hookFunc {string} 替换的hook函数
     * + context {object} 目标函数所在对象,用于hook非window对象下的函数，如String.protype.slice,carInstance1
     * + methodName {string} 匿名函数需显式传入目标函数名eg:this.Begin = function(){....};}
     *
     * .unhook
     * + realFunc {string} 用于保存原始函数的函数名称,用于unHook
     * + funcName {string} 被Hook的函数名称
     * + context {object} 目标函数所在对象,用于hook非window对象下的函数，如String.protype.slice,carInstance1
     * @example
      let hook = new Utils.Hooks();
      hook.initEnv();
      function myFunction(){
          console.log("我自己需要执行的函数");
      }
      function testFunction(){
          console.log("正常执行的函数");
      }
      testFunction.hook(testFunction,myFunction,window);
     **/
    Hooks = Hooks;
    /**
     * 为减少代码量和回调，把GM_xmlhttpRequest封装
     * 文档地址: https://www.tampermonkey.net/documentation.php?ext=iikm
     * 其中onloadstart、onprogress、onreadystatechange是回调形式，onabort、ontimeout、onerror可以设置全局回调函数
     * @param _GM_xmlHttpRequest_ 油猴中的GM_xmlhttpRequest
     * @example
      let httpx = new Utils.Httpx(GM_xmlhttpRequest);
      let postResp = await httpx.post({
        url:url,
        data:JSON.stringify({
          test:1
        }),
        timeout: 5000
      });
      console.log(postResp);
      > {
        status: true,
        data: {responseText: "...", response: xxx,...},
        msg: "请求完毕",
        type: "onload",
      }
  
      if(postResp === "onload" && postResp.status){
      // onload
      }else if(postResp === "ontimeout"){
      // ontimeout
      }
     * @example
      // 也可以先配置全局参数
      let httpx = new Utils.Httpx(GM_xmlhttpRequest);
      httpx.config({
        timeout: 5000,
        async: false,
        responseType: "html",
        redirect: "follow",
      })
      // 优先级为 默认details < 全局details < 单独的details
     */
    Httpx = Httpx;
    /**
     * 浏览器端的indexedDB操作封装
     * @example
      let db = new Utils.indexedDB('web_DB', 'nav_text')
      let data = {name:'管理员', roleId: 1, type: 1};
      db.save('list',data).then((resolve)=>{
          console.log(resolve,'存储成功')
      })
  
      db.get('list').then((resolve)=>{
          console.log(resolve,'查询成功')
      })
  
      db.getPaging('list',20,10).then((resolve)=>{
          console.log(resolve,'查询分页偏移第20，一共10行成功');
      })
  
      db.delete('list').then(resolve=>{
          console.log(resolve,'删除成功---->>>>>>name')
      })
  
      db.deleteAll().then(resolve=>{
          console.log(resolve,'清除数据库---->>>>>>name')
      })
     **/
    indexedDB = indexedDB;
    isNativeFunc(target) {
        return Boolean(target.toString().match(/^function .*\(\) { \[native code\] }$/));
    }
    isNearBottom(...args) {
        let nearBottomHeight = 50;
        let checkWindow = () => {
            // 已滚动的距离
            let scrollTop = this.windowApi.window.pageYOffset ||
                this.windowApi.document.documentElement.scrollTop;
            // 视窗高度
            let viewportHeight = this.windowApi.window.innerHeight ||
                this.windowApi.document.documentElement.clientHeight;
            // 最大滚动距离
            let maxScrollHeight = this.windowApi.document.documentElement.scrollHeight - nearBottomHeight;
            return scrollTop + viewportHeight >= maxScrollHeight;
        };
        let checkNode = ($ele) => {
            // 已滚动的距离
            let scrollTop = $ele.scrollTop;
            // 视窗高度
            let viewportHeight = $ele.clientHeight;
            // 最大滚动距离
            let maxScrollHeight = $ele.scrollHeight - viewportHeight - nearBottomHeight;
            return scrollTop >= maxScrollHeight;
        };
        let firstArg = args[0];
        if (args.length === 0 || typeof args[0] === "number") {
            // nearBottomHeight
            //
            return checkWindow();
        }
        else if (typeof args[0] === "object" && args[0] instanceof HTMLElement) {
            // target
            // target，nearBottomHeight
            if (typeof args[1] === "number" && !Number.isNaN(args[1])) {
                nearBottomHeight = args[1];
            }
            return checkNode(args[0]);
        }
        else {
            throw new TypeError("参数1类型错误" + typeof firstArg);
        }
    }
    isDOM(target) {
        return target instanceof Node;
    }
    isFullscreenEnabled() {
        return !!(this.windowApi.document.fullscreenEnabled ||
            this.windowApi.document.webkitFullScreenEnabled ||
            this.windowApi.document.mozFullScreenEnabled ||
            this.windowApi.document.msFullScreenEnabled);
    }
    isJQuery(target) {
        let result = false;
        // @ts-ignore
        if (typeof jQuery === "object" && target instanceof jQuery) {
            result = true;
        }
        if (target == null) {
            return false;
        }
        if (typeof target === "object") {
            /* 也有种可能，这个jQuery对象是1.8.3版本的，页面中的jQuery是3.4.1版本的 */
            let jQueryProps = [
                "add",
                "addBack",
                "addClass",
                "after",
                "ajaxComplete",
                "ajaxError",
                "ajaxSend",
                "ajaxStart",
                "ajaxStop",
                "ajaxSuccess",
                "animate",
                "append",
                "appendTo",
                "attr",
                "before",
                "bind",
                "blur",
                "change",
                "children",
                "clearQueue",
                "click",
                "clone",
                "closest",
                "constructor",
                "contents",
                "contextmenu",
                "css",
                "data",
                "dblclick",
                "delay",
                "delegate",
                "dequeue",
                "each",
                "empty",
                "end",
                "eq",
                "extend",
                "fadeIn",
                "fadeOut",
                "fadeTo",
                "fadeToggle",
                "filter",
                "find",
                "first",
                "focus",
                "focusin",
                "focusout",
                "get",
                "has",
                "hasClass",
                "height",
                "hide",
                "hover",
                "html",
                "index",
                "init",
                "innerHeight",
                "innerWidth",
                "insertAfter",
                "insertBefore",
                "is",
                "jquery",
                "keydown",
                "keypress",
                "keyup",
                "last",
                "load",
                "map",
                "mousedown",
                "mouseenter",
                "mouseleave",
                "mousemove",
                "mouseout",
                "mouseover",
                "mouseup",
                "next",
                "nextAll",
                "not",
                "off",
                "offset",
                "offsetParent",
                "on",
                "one",
                "outerHeight",
                "outerWidth",
                "parent",
                "parents",
                "position",
                "prepend",
                "prependTo",
                "prev",
                "prevAll",
                "prevUntil",
                "promise",
                "prop",
                "pushStack",
                "queue",
                "ready",
                "remove",
                "removeAttr",
                "removeClass",
                "removeData",
                "removeProp",
                "replaceAll",
                "replaceWith",
                "resize",
                "scroll",
                "scrollLeft",
                "scrollTop",
                "select",
                "show",
                "siblings",
                "slice",
                "slideDown",
                "slideToggle",
                "slideUp",
                "sort",
                "splice",
                "text",
                "toArray",
                "toggle",
                "toggleClass",
                "trigger",
                "triggerHandler",
                "unbind",
                "width",
                "wrap",
            ];
            for (const jQueryPropsName of jQueryProps) {
                if (!(jQueryPropsName in target)) {
                    result = false;
                    /* console.log(jQueryPropsName); */
                    break;
                }
                else {
                    result = true;
                }
            }
        }
        return result;
    }
    isPhone(userAgent = navigator.userAgent) {
        return Boolean(/(iPhone|iPad|iPod|iOS|Android|Mobile)/i.test(userAgent));
    }
    isSameChars(targetStr, coefficient = 1) {
        if (typeof targetStr !== "string") {
            throw new TypeError("参数 str 必须是 string 类型");
        }
        if (targetStr.length < 2) {
            return false;
        }
        targetStr = targetStr.toLowerCase();
        const targetCharMap = {};
        let targetStrLength = 0;
        for (const char of targetStr) {
            if (Reflect.has(targetCharMap, char)) {
                targetCharMap[char]++;
            }
            else {
                targetCharMap[char] = 1;
            }
            targetStrLength++;
        }
        let result = false;
        for (const char in targetCharMap) {
            if (targetCharMap[char] / targetStrLength >= coefficient) {
                result = true;
                break;
            }
        }
        return result;
    }
    isNotNull(...args) {
        let UtilsContext = this;
        return !UtilsContext.isNull.apply(this, args);
    }
    isNull(...args) {
        let result = true;
        let checkList = [...args];
        for (const objItem of checkList) {
            let itemResult = false;
            if (objItem === null || objItem === undefined) {
                itemResult = true;
            }
            else {
                switch (typeof objItem) {
                    case "object":
                        if (typeof objItem[Symbol.iterator] === "function") {
                            /* 可迭代 */
                            itemResult = objItem.length === 0;
                        }
                        else {
                            itemResult = Object.keys(objItem).length === 0;
                        }
                        break;
                    case "number":
                        itemResult = objItem === 0;
                        break;
                    case "string":
                        itemResult =
                            objItem.trim() === "" ||
                                objItem === "null" ||
                                objItem === "undefined";
                        break;
                    case "boolean":
                        itemResult = !objItem;
                        break;
                    case "function":
                        let funcStr = objItem.toString().replace(/\s/g, "");
                        /* 排除()=>{}、(xxx="")=>{}、function(){}、function(xxx=""){} */
                        itemResult = Boolean(funcStr.match(/^\(.*?\)=>\{\}$|^function.*?\(.*?\)\{\}$/));
                        break;
                }
            }
            result = result && itemResult;
        }
        return result;
    }
    isThemeDark() {
        return this.windowApi.globalThis.matchMedia("(prefers-color-scheme: dark)")
            .matches;
    }
    /**
     * 判断元素是否在页面中可见
     * @param element 需要检查的元素，可以是普通元素|数组形式的元素|通过querySelectorAll获取的元素数组
     * @param inView
     * + true 在窗口可视区域
     * + false 不在窗口可视区域
     * @returns
     * + true 可见
     * + false 不可见
     * @example
     * Utils.isVisible(document.documentElement)
     * > true
     */
    isVisible(element, inView = false) {
        let needCheckDomList = [];
        if (element instanceof Array || element instanceof NodeList) {
            element = element;
            needCheckDomList = [...element];
        }
        else {
            needCheckDomList = [element];
        }
        let result = true;
        for (const domItem of needCheckDomList) {
            let domDisplay = this.windowApi.window.getComputedStyle(domItem);
            if (domDisplay.display === "none") {
                result = false;
            }
            else {
                let domClientRect = domItem.getBoundingClientRect();
                if (inView) {
                    let viewportWidth = this.windowApi.window.innerWidth ||
                        this.windowApi.document.documentElement.clientWidth;
                    let viewportHeight = this.windowApi.window.innerHeight ||
                        this.windowApi.document.documentElement.clientHeight;
                    result = !(domClientRect.right < 0 ||
                        domClientRect.left > viewportWidth ||
                        domClientRect.bottom < 0 ||
                        domClientRect.top > viewportHeight);
                }
                else {
                    result = Boolean(domItem.getClientRects().length);
                }
            }
            if (!result) {
                /* 有一个不可见就退出循环 */
                break;
            }
        }
        return result;
    }
    isWebView_Via() {
        let result = true;
        let UtilsContext = this;
        if (typeof this.windowApi.top.window.via === "object") {
            for (const key in Object.values(this.windowApi.top.window.via)) {
                if (Reflect.has(this.windowApi.top.window.via, key)) {
                    let objValueFunc = this.windowApi.top.window.via[key];
                    if (typeof objValueFunc === "function" &&
                        UtilsContext.isNativeFunc(objValueFunc)) {
                        result = true;
                    }
                    else {
                        result = false;
                        break;
                    }
                }
            }
        }
        else {
            result = false;
        }
        return result;
    }
    isWebView_X() {
        let result = true;
        let UtilsContext = this;
        if (typeof this.windowApi.top.window.mbrowser === "object") {
            for (const key in Object.values(this.windowApi.top.window.mbrowser)) {
                if (Reflect.has(this.windowApi.top.window.mbrowser, key)) {
                    let objValueFunc = this.windowApi.top.window.mbrowser[key];
                    if (typeof objValueFunc === "function" &&
                        UtilsContext.isNativeFunc(objValueFunc)) {
                        result = true;
                    }
                    else {
                        result = false;
                        break;
                    }
                }
            }
        }
        else {
            result = false;
        }
        return result;
    }
    parseObjectToArray(target) {
        if (typeof target !== "object") {
            throw new Error("Utils.parseObjectToArray 参数 target 必须为 object 类型");
        }
        let result = [];
        Object.keys(target).forEach(function (keyName) {
            result = result.concat(target[keyName]);
        });
        return result;
    }
    /**
     * 自动锁对象，用于循环判断运行的函数，在循环外new后使用，注意，如果函数内部存在异步操作，需要使用await
     * @example
      let lock = new Utils.LockFunction(()=>{console.log(1)}))
      lock.run();
      > 1
     * @example
      let lock = new Utils.LockFunction(()=>{console.log(1)}),true) -- 异步操作
      await lock.run();
      > 1
     **/
    LockFunction = LockFunction;
    /**
     * 日志对象
     * @param _GM_info_ 油猴管理器的API GM_info，或者是一个对象，如{"script":{name:"Utils.Log"}}
     * @example
      let log = new Utils.Log(GM_info);
      log.info("普通输出");
      > 普通输出
  
      log.success("成功输出");
      > 成功输出
  
      log.error("错误输出");
      > 错误输出
      
      log.warn("警告输出");
      > 警告输出
  
      log.tag = "自定义tag信息";
      log.info("自定义info的颜色","#e0e0e0");
      > 自定义info的颜色
  
      log.config({
        successColor: "#31dc02",
        errorColor: "#e02d2d",
        infoColor: "black",
      })
      log.success("颜色为#31dc02");
      > 颜色为#31dc02
     */
    Log = Log;
    mergeArrayToString(data, handleFunc) {
        if (!(data instanceof Array)) {
            throw new Error("Utils.mergeArrayToString 参数 data 必须为 Array 类型");
        }
        let content = "";
        if (typeof handleFunc === "function") {
            data.forEach((item) => {
                content += handleFunc(item);
            });
        }
        else if (typeof handleFunc === "string") {
            data.forEach((item) => {
                content += item[handleFunc];
            });
        }
        else {
            data.forEach((item) => {
                Object.values(item)
                    .filter((item2) => typeof item2 === "string")
                    .forEach((item3) => {
                    content += item3;
                });
            });
        }
        return content;
    }
    mutationObserver(target, observer_config) {
        let UtilsContext = this;
        let default_obverser_config = {
            /* 监听到元素有反馈，需执行的函数 */
            callback: () => { },
            config: {
                /**
                 * + true 监听以 target 为根节点的整个子树。包括子树中所有节点的属性，而不仅仅是针对 target
                 * + false (默认) 不生效
                 */
                subtree: void 0,
                /**
                 * + true 监听 target 节点中发生的节点的新增与删除（同时，如果 subtree 为 true，会针对整个子树生效）
                 * + false (默认) 不生效
                 */
                childList: void 0,
                /**
                 * + true 观察所有监听的节点属性值的变化。默认值为 true，当声明了 attributeFilter 或 attributeOldValue
                 * + false (默认) 不生效
                 */
                attributes: void 0,
                /**
                 * 一个用于声明哪些属性名会被监听的数组。如果不声明该属性，所有属性的变化都将触发通知
                 */
                attributeFilter: void 0,
                /**
                 * + true 记录上一次被监听的节点的属性变化；可查阅 MutationObserver 中的 Monitoring attribute values 了解关于观察属性变化和属性值记录的详情
                 * + false (默认) 不生效
                 */
                attributeOldValue: void 0,
                /**
                 * + true 监听声明的 target 节点上所有字符的变化。默认值为 true，如果声明了 characterDataOldValue
                 * + false (默认) 不生效
                 */
                characterData: void 0,
                /**
                 * + true 记录前一个被监听的节点中发生的文本变化
                 * + false (默认) 不生效
                 */
                characterDataOldValue: void 0,
            },
            immediate: false,
        };
        observer_config = UtilsContext.assign(default_obverser_config, observer_config);
        let windowMutationObserver = this.windowApi.window.MutationObserver ||
            this.windowApi.window.webkitMutationObserver ||
            this.windowApi.window.MozMutationObserver;
        // 观察者对象
        let mutationObserver = new windowMutationObserver(function (mutations, observer) {
            if (typeof observer_config.callback === "function") {
                observer_config.callback(mutations, observer);
            }
        });
        if (Array.isArray(target) || target instanceof NodeList) {
            // 传入的是数组或者元素数组
            target.forEach((item) => {
                mutationObserver.observe(item, observer_config.config);
            });
        }
        else if (UtilsContext.isJQuery(target)) {
            /* 传入的参数是jQuery对象 */
            target.each((index, item) => {
                mutationObserver.observe(item, observer_config.config);
            });
        }
        else {
            mutationObserver.observe(target, observer_config.config);
        }
        if (observer_config.immediate) {
            /* 主动触发一次 */
            if (typeof observer_config.callback === "function") {
                observer_config.callback([], mutationObserver);
            }
        }
        return mutationObserver;
    }
    /**
     * 使用观察器观察元素出现在视图内，出现的话触发回调
     * @param target 目标元素
     * @param callback 触发的回调
     * @param options 观察器配置
     * @example
     * Utils.mutationVisible(document.querySelector("div.xxxx"),(entries,observer)=>{
     *     console.log("该元素出现在视图内");
     * }))
     */
    mutationVisible(target, callback, options) {
        if (typeof IntersectionObserver === "undefined") {
            throw new TypeError("IntersectionObserver is not defined");
        }
        if (target == null) {
            throw new TypeError("mutatuinVisible target is null");
        }
        let defaultOptions = {
            root: null,
            rootMargin: "0px 0px 0px 0px",
            threshold: [0.01, 0.99],
        };
        defaultOptions = this.assign(defaultOptions, options || {});
        let intersectionObserver = new IntersectionObserver((entries, observer) => {
            if (entries[0].isIntersecting) {
                if (typeof callback === "function") {
                    callback(entries, observer);
                }
            }
        }, defaultOptions);
        if (Array.isArray(target)) {
            target.forEach((item) => {
                intersectionObserver.observe(item);
            });
        }
        else {
            intersectionObserver.observe(target);
        }
    }
    /**
     * 去除全局window下的Utils，返回控制权
     * @example
     * let utils = Utils.noConflict();
     * > ...
     */
    noConflict() {
        if (this.windowApi.window.Utils) {
            Reflect.deleteProperty(this.windowApi.window, "Utils");
        }
        this.windowApi.window.Utils = utils;
        return utils;
    }
    noConflictFunc(needReleaseObject, needReleaseName, functionNameList = [], release = true) {
        let UtilsContext = this;
        if (typeof needReleaseObject !== "object") {
            throw new Error("Utils.noConflictFunc 参数 needReleaseObject 必须为 object 类型");
        }
        if (typeof needReleaseName !== "string") {
            throw new Error("Utils.noConflictFunc 参数 needReleaseName 必须为 string 类型");
        }
        if (!Array.isArray(functionNameList)) {
            throw new Error("Utils.noConflictFunc 参数 functionNameList 必须为 Array 类型");
        }
        let needReleaseKey = "__" + needReleaseName;
        /**
         * 释放所有
         */
        function releaseAll() {
            if (typeof UtilsContext.windowApi.window[needReleaseKey] !==
                "undefined") {
                /* 已存在 */
                return;
            }
            UtilsContext.windowApi.window[needReleaseKey] =
                UtilsContext.deepClone(needReleaseObject);
            Object.values(needReleaseObject).forEach((value) => {
                if (typeof value === "function") {
                    needReleaseObject[value.name] = () => { };
                }
            });
        }
        /**
         * 释放单个
         */
        function releaseOne() {
            Array.from(functionNameList).forEach((item) => {
                Object.values(needReleaseObject).forEach((value) => {
                    if (typeof value === "function") {
                        if (typeof UtilsContext.windowApi.window[needReleaseKey] ===
                            "undefined") {
                            UtilsContext.windowApi.window[needReleaseKey] = {};
                        }
                        if (item === value.name) {
                            UtilsContext.windowApi.window[needReleaseKey][value.name] = needReleaseObject[value.name];
                            needReleaseObject[value.name] = () => { };
                        }
                    }
                });
            });
        }
        /**
         * 恢复所有
         */
        function recoveryAll() {
            if (typeof UtilsContext.windowApi.window[needReleaseKey] ===
                "undefined") {
                /* 未存在 */
                return;
            }
            Object.assign(needReleaseObject, UtilsContext.windowApi.window[needReleaseKey]);
            Reflect.deleteProperty(UtilsContext.windowApi.window, "needReleaseKey");
        }
        /**
         * 恢复单个
         */
        function recoveryOne() {
            if (typeof UtilsContext.windowApi.window[needReleaseKey] ===
                "undefined") {
                /* 未存在 */
                return;
            }
            Array.from(functionNameList).forEach((item) => {
                if (UtilsContext.windowApi.window[needReleaseKey][item]) {
                    needReleaseObject[item] = UtilsContext.windowApi.window[needReleaseKey][item];
                    Reflect.deleteProperty(UtilsContext.windowApi.window[needReleaseKey], item);
                    if (Object.keys(UtilsContext.windowApi.window[needReleaseKey])
                        .length === 0) {
                        Reflect.deleteProperty(window, needReleaseKey);
                    }
                }
            });
        }
        if (release) {
            /* 释放 */
            if (functionNameList.length === 0) {
                releaseAll();
            }
            else {
                /* 对单个进行操作 */
                releaseOne();
            }
        }
        else {
            /* 恢复 */
            if (functionNameList.length === 0) {
                recoveryAll();
            }
            else {
                /* 对单个进行操作 */
                recoveryOne();
            }
        }
    }
    parseBase64ToBlob(dataUri) {
        if (typeof dataUri !== "string") {
            throw new Error("Utils.parseBase64ToBlob 参数 dataUri 必须为 string 类型");
        }
        let dataUriSplit = dataUri.split(","), dataUriMime = dataUriSplit[0].match(/:(.*?);/)[1], dataUriBase64Str = atob(dataUriSplit[1]), dataUriLength = dataUriBase64Str.length, u8arr = new Uint8Array(dataUriLength);
        while (dataUriLength--) {
            u8arr[dataUriLength] = dataUriBase64Str.charCodeAt(dataUriLength);
        }
        return new Blob([u8arr], {
            type: dataUriMime,
        });
    }
    parseBase64ToFile(dataUri, fileName = "example") {
        if (typeof dataUri !== "string") {
            throw new Error("Utils.parseBase64ToFile 参数 dataUri 必须为 string 类型");
        }
        if (typeof fileName !== "string") {
            throw new Error("Utils.parseBase64ToFile 参数 fileName 必须为 string 类型");
        }
        let dataUriSplit = dataUri.split(","), dataUriMime = dataUriSplit[0].match(/:(.*?);/)[1], dataUriBase64Str = atob(dataUriSplit[1]), dataUriLength = dataUriBase64Str.length, u8arr = new Uint8Array(dataUriLength);
        while (dataUriLength--) {
            u8arr[dataUriLength] = dataUriBase64Str.charCodeAt(dataUriLength);
        }
        return new File([u8arr], fileName, {
            type: dataUriMime,
        });
    }
    parseInt(matchList = [], defaultValue = 0) {
        if (matchList == null) {
            return parseInt(defaultValue.toString());
        }
        let parseValue = parseInt(matchList[matchList.length - 1]);
        if (isNaN(parseValue)) {
            parseValue = parseInt(defaultValue.toString());
        }
        return parseValue;
    }
    async parseBlobToFile(blobUrl, fileName = "example") {
        return new Promise((resolve, reject) => {
            fetch(blobUrl)
                .then((response) => response.blob())
                .then((blob) => {
                const file = new File([blob], fileName, { type: blob.type });
                resolve(file);
            })
                .catch((error) => {
                console.error("Error:", error);
                reject(error);
            });
        });
    }
    parseCDATA(text = "") {
        let result = "";
        let cdataRegexp = /<\!\[CDATA\[([\s\S]*)\]\]>/;
        let cdataMatch = cdataRegexp.exec(text.trim());
        if (cdataMatch && cdataMatch.length > 1) {
            result = cdataMatch[cdataMatch.length - 1];
        }
        return result;
    }
    async parseFileToBase64(fileObj) {
        let reader = new FileReader();
        reader.readAsDataURL(fileObj);
        return new Promise((resolve) => {
            reader.onload = function (event) {
                resolve(event.target.result);
            };
        });
    }
    parseFromString(text, mimeType = "text/html") {
        let parser = new DOMParser();
        return parser.parseFromString(text, mimeType);
    }
    parseStringToRegExpString(text) {
        if (typeof text !== "string") {
            throw new TypeError("string必须是字符串");
        }
        let regString = text.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
        return regString;
    }
    preventEvent(element, eventNameList = [], capture) {
        function stopEvent(event) {
            /* 阻止事件的默认行为发生。例如，当点击一个链接时，浏览器会默认打开链接的URL */
            event?.preventDefault();
            /* 停止事件的传播，阻止它继续向更上层的元素冒泡，事件将不会再传播给其他的元素 */
            event?.stopPropagation();
            /* 阻止事件传播，并且还能阻止元素上的其他事件处理程序被触发 */
            event?.stopImmediatePropagation();
            return false;
        }
        if (arguments.length === 1) {
            /* 直接阻止事件 */
            return stopEvent(arguments[0]);
        }
        else {
            /* 添加对应的事件来阻止触发 */
            if (typeof eventNameList === "string") {
                eventNameList = [eventNameList];
            }
            eventNameList.forEach((eventName) => {
                element.addEventListener(eventName, stopEvent, {
                    capture: Boolean(capture),
                });
            });
        }
    }
    /**
     * 在canvas元素节点上绘制进度圆圈
     * @example
      let progress = new Utils.Process({canvasNode:document.querySelector("canvas")});
      progress.draw();
     * **/
    Progress = Progress;
    registerTrustClickEvent(isTrustValue = true, filter) {
        function trustEvent(event) {
            return new Proxy(event, {
                get: function (target, property) {
                    if (property === "isTrusted") {
                        return isTrustValue;
                    }
                    else {
                        return Reflect.get(target, property);
                    }
                },
            });
        }
        if (filter == null) {
            filter = function (typeName) {
                return typeName === "click";
            };
        }
        const originalListener = EventTarget.prototype.addEventListener;
        EventTarget.prototype.addEventListener = function (...args) {
            let type = args[0];
            let callback = args[1];
            // @ts-ignore
            let options = args[2];
            if (filter(type)) {
                if (typeof callback === "function") {
                    args[1] = function (event) {
                        callback.call(this, trustEvent(event));
                    };
                }
                else if (typeof callback === "object" &&
                    "handleEvent" in callback) {
                    let oldHandleEvent = callback["handleEvent"];
                    args[1]["handleEvent"] = function (event) {
                        if (event == null) {
                            return;
                        }
                        try {
                            /* Proxy对象使用instanceof会报错 */
                            event instanceof Proxy;
                            oldHandleEvent.call(this, trustEvent(event));
                        }
                        catch (error) {
                            // @ts-ignore
                            event["isTrusted"] = isTrustValue;
                        }
                    };
                }
            }
            return originalListener.apply(this, args);
        };
    }
    reverseNumber(num) {
        let reversedNum = 0;
        let isNegative = false;
        if (num < 0) {
            isNegative = true;
            num = Math.abs(num);
        }
        while (num > 0) {
            reversedNum = reversedNum * 10 + (num % 10);
            num = Math.floor(num / 10);
        }
        return isNegative ? -reversedNum : reversedNum;
    }
    selectElementText(element, childTextNode, startIndex, endIndex) {
        let range = this.windowApi.document.createRange();
        range.selectNodeContents(element);
        if (childTextNode) {
            if (childTextNode.nodeType !== Node.TEXT_NODE) {
                throw new TypeError("childTextNode必须是#text元素");
            }
            if (startIndex != null && endIndex != null) {
                range.setStart(childTextNode, startIndex);
                range.setEnd(childTextNode, endIndex);
            }
        }
        let selection = this.windowApi.globalThis.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
    setClip(data, info = {
        type: "text",
        mimetype: "text/plain",
    }) {
        if (typeof data === "object") {
            if (data instanceof Element) {
                data = data.outerHTML;
            }
            else {
                data = JSON.stringify(data);
            }
        }
        else if (typeof data !== "string") {
            data = data.toString();
        }
        let textType = typeof info === "object" ? info.type : info;
        if (textType.includes("html")) {
            textType = "text/html";
        }
        else {
            textType = "text/plain";
        }
        let UtilsContext = this;
        class UtilsClipboard {
            #resolve;
            #copyData;
            #copyDataType;
            constructor(resolve, copyData, copyDataType) {
                this.#resolve = resolve;
                this.#copyData = copyData;
                this.#copyDataType = copyDataType;
            }
            async init() {
                let copyStatus = false;
                // @ts-ignore
                let requestPermissionStatus = await this.requestClipboardPermission();
                if (this.hasClipboard() &&
                    (this.hasClipboardWrite() || this.hasClipboardWriteText())) {
                    try {
                        copyStatus = await this.copyDataByClipboard();
                    }
                    catch (error) {
                        console.error("复制失败，使用第二种方式，error👉", error);
                        copyStatus = this.copyTextByTextArea();
                    }
                }
                else {
                    copyStatus = this.copyTextByTextArea();
                }
                this.#resolve(copyStatus);
                this.destroy();
            }
            destroy() {
                // @ts-ignore
                this.#resolve = null;
                // @ts-ignore
                this.#copyData = null;
                // @ts-ignore
                this.#copyDataType = null;
            }
            isText() {
                return this.#copyDataType.includes("text");
            }
            hasClipboard() {
                return navigator?.clipboard != null;
            }
            hasClipboardWrite() {
                return navigator?.clipboard?.write != null;
            }
            hasClipboardWriteText() {
                return navigator?.clipboard?.writeText != null;
            }
            /**
             * 使用textarea和document.execCommand("copy")来复制文字
             */
            copyTextByTextArea() {
                try {
                    let copyElement = UtilsContext.windowApi.document.createElement("textarea");
                    copyElement.value = this.#copyData;
                    copyElement.setAttribute("type", "text");
                    copyElement.setAttribute("style", "opacity:0;position:absolute;");
                    copyElement.setAttribute("readonly", "readonly");
                    UtilsContext.windowApi.document.body.appendChild(copyElement);
                    copyElement.select();
                    UtilsContext.windowApi.document.execCommand("copy");
                    UtilsContext.windowApi.document.body.removeChild(copyElement);
                    return true;
                }
                catch (error) {
                    console.error("复制失败，error👉", error);
                    return false;
                }
            }
            /**
             * 申请剪贴板权限
             */
            requestClipboardPermission() {
                return new Promise((resolve, reject) => {
                    if (navigator.permissions && navigator.permissions.query) {
                        navigator.permissions
                            .query({
                            // @ts-ignore
                            name: "clipboard-write",
                        })
                            .then((permissionStatus) => {
                            resolve(true);
                        })
                            .catch((error) => {
                            console.error([
                                "申请剪贴板权限失败，尝试直接写入👉",
                                error.message ?? error.name ?? error.stack,
                            ]);
                            resolve(false);
                        });
                    }
                    else {
                        resolve(false);
                    }
                });
            }
            /**
             * 使用clipboard直接写入数据到剪贴板
             */
            copyDataByClipboard() {
                return new Promise((resolve, reject) => {
                    if (this.isText()) {
                        /* 只复制文字 */
                        navigator.clipboard
                            .writeText(this.#copyData)
                            .then(() => {
                            resolve(true);
                        })
                            .catch((error) => {
                            reject(error);
                        });
                    }
                    else {
                        /* 可复制对象 */
                        let textBlob = new Blob([this.#copyData], {
                            type: this.#copyDataType,
                        });
                        navigator.clipboard
                            .write([
                            new ClipboardItem({
                                [this.#copyDataType]: textBlob,
                            }),
                        ])
                            .then(() => {
                            resolve(true);
                        })
                            .catch((error) => {
                            reject(error);
                        });
                    }
                });
            }
        }
        return new Promise((resolve) => {
            const utilsClipboard = new UtilsClipboard(resolve, data, textType);
            if (UtilsContext.windowApi.document.hasFocus()) {
                utilsClipboard.init();
            }
            else {
                UtilsContext.windowApi.window.addEventListener("focus", () => {
                    utilsClipboard.init();
                }, { once: true });
            }
        });
    }
    setTimeout(callback, delayTime = 0) {
        let UtilsContext = this;
        if (typeof callback !== "function" && typeof callback !== "string") {
            throw new TypeError("Utils.setTimeout 参数 callback 必须为 function|string 类型");
        }
        if (typeof delayTime !== "number") {
            throw new TypeError("Utils.setTimeout 参数 delayTime 必须为 number 类型");
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(UtilsContext.tryCatch().run(callback));
            }, delayTime);
        });
    }
    sleep(delayTime = 0) {
        if (typeof delayTime !== "number") {
            throw new Error("Utils.sleep 参数 delayTime 必须为 number 类型");
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(void 0);
            }, delayTime);
        });
    }
    dragSlider(selector, offsetX = this.windowApi.window.innerWidth) {
        let UtilsContext = this;
        function initMouseEvent(eventName, offSetX, offSetY) {
            // @ts-ignore
            let win = typeof unsafeWindow === "undefined" ? globalThis : unsafeWindow;
            let mouseEvent = UtilsContext.windowApi.document.createEvent("MouseEvents");
            mouseEvent.initMouseEvent(eventName, true, true, win, 0, offSetX, offSetY, offSetX, offSetY, false, false, false, false, 0, null);
            return mouseEvent;
        }
        let sliderElement = typeof selector === "string"
            ? this.windowApi.document.querySelector(selector)
            : selector;
        if (!(sliderElement instanceof Node) ||
            !(sliderElement instanceof Element)) {
            throw new Error("Utils.dragSlider 参数selector 必须为Node/Element类型");
        }
        let rect = sliderElement.getBoundingClientRect(), x0 = rect.x || rect.left, y0 = rect.y || rect.top, x1 = x0 + offsetX, y1 = y0;
        sliderElement.dispatchEvent(initMouseEvent("mousedown", x0, y0));
        sliderElement.dispatchEvent(initMouseEvent("mousemove", x1, y1));
        sliderElement.dispatchEvent(initMouseEvent("mouseleave", x1, y1));
        sliderElement.dispatchEvent(initMouseEvent("mouseout", x1, y1));
    }
    enterFullScreen(element = this.windowApi.document.documentElement, options) {
        try {
            if (element.requestFullscreen) {
                element.requestFullscreen(options);
            }
            else if (element.webkitRequestFullScreen) {
                element.webkitRequestFullScreen();
            }
            else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            }
            else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
            else {
                throw new TypeError("该浏览器不支持全屏API");
            }
        }
        catch (err) {
            console.error(err);
        }
    }
    exitFullScreen(element = this.windowApi.document.documentElement) {
        if (this.windowApi.document.exitFullscreen) {
            return this.windowApi.document.exitFullscreen();
        }
        else if (this.windowApi.document.msExitFullscreen) {
            return this.windowApi.document.msExitFullscreen();
        }
        else if (this.windowApi.document.mozCancelFullScreen) {
            return this.windowApi.document.mozCancelFullScreen();
        }
        else if (this.windowApi.document.webkitCancelFullScreen) {
            return this.windowApi.document.webkitCancelFullScreen();
        }
        else {
            return new Promise((resolve, reject) => {
                reject(new TypeError("该浏览器不支持全屏API"));
            });
        }
    }
    sortListByProperty(data, getPropertyValueFunc, sortByDesc = true) {
        let UtilsContext = this;
        if (typeof getPropertyValueFunc !== "function" &&
            typeof getPropertyValueFunc !== "string") {
            throw new Error("Utils.sortListByProperty 参数 getPropertyValueFunc 必须为 function|string 类型");
        }
        if (typeof sortByDesc !== "boolean") {
            throw new Error("Utils.sortListByProperty 参数 sortByDesc 必须为 boolean 类型");
        }
        let getObjValue = function (obj) {
            return typeof getPropertyValueFunc === "string"
                ? obj[getPropertyValueFunc]
                : getPropertyValueFunc(obj);
        };
        /**
         * 排序方法
         * @param {any} after_obj
         * @param {any} before_obj
         * @returns
         */
        let sortFunc = function (after_obj, before_obj) {
            let beforeValue = getObjValue(before_obj); /*  前 */
            let afterValue = getObjValue(after_obj); /* 后 */
            if (sortByDesc) {
                if (afterValue > beforeValue) {
                    return -1;
                }
                else if (afterValue < beforeValue) {
                    return 1;
                }
                else {
                    return 0;
                }
            }
            else {
                if (afterValue < beforeValue) {
                    return -1;
                }
                else if (afterValue > beforeValue) {
                    return 1;
                }
                else {
                    return 0;
                }
            }
        };
        /**
         * 排序元素方法
         * @param  nodeList 元素列表
         * @param getNodeListFunc 获取元素列表的函数
         */
        let sortNodeFunc = function (nodeList, getNodeListFunc) {
            let nodeListLength = nodeList.length;
            for (let i = 0; i < nodeListLength - 1; i++) {
                for (let j = 0; j < nodeListLength - 1 - i; j++) {
                    let beforeNode = nodeList[j];
                    let afterNode = nodeList[j + 1];
                    let beforeValue = getObjValue(beforeNode); /*  前 */
                    let afterValue = getObjValue(afterNode); /* 后 */
                    if ((sortByDesc == true && beforeValue < afterValue) ||
                        (sortByDesc == false && beforeValue > afterValue)) {
                        /* 升序/降序 */
                        /* 相邻元素两两对比 */
                        let temp = beforeNode.nextElementSibling;
                        afterNode.after(beforeNode);
                        if (temp == null) {
                            /* 如果为空，那么是最后一个元素，使用append */
                            temp.parentNode.appendChild(afterNode);
                        }
                        else {
                            /* 不为空，使用before */
                            temp.before(afterNode);
                        }
                        nodeList = getNodeListFunc();
                    }
                }
            }
        };
        let result = data;
        let getDataFunc = null;
        if (data instanceof Function) {
            getDataFunc = data;
            data = data();
        }
        if (Array.isArray(data)) {
            data.sort(sortFunc);
        }
        else if (data instanceof NodeList ||
            UtilsContext.isJQuery(data)) {
            sortNodeFunc(data, getDataFunc);
            result = getDataFunc();
        }
        else {
            throw new Error("Utils.sortListByProperty 参数 data 必须为 Array|NodeList|jQuery 类型");
        }
        return result;
    }
    stringToRegular(targetString, flags = "ig") {
        let reg;
        // @ts-ignore
        flags = flags.toLowerCase();
        if (typeof targetString === "string") {
            reg = new RegExp(targetString.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&"), flags);
        }
        else if (targetString instanceof RegExp) {
            reg = targetString;
        }
        else {
            throw new Error("Utils.stringToRegular 参数targetString必须是string|Regexp类型");
        }
        return reg;
    }
    stringTitleToUpperCase(targetString, otherStrToLowerCase = false) {
        let newTargetString = targetString.slice(0, 1).toUpperCase();
        if (otherStrToLowerCase) {
            newTargetString = newTargetString + targetString.slice(1).toLowerCase();
        }
        else {
            newTargetString = newTargetString + targetString.slice(1);
        }
        return newTargetString;
    }
    startsWith(target, searchString, position = 0) {
        let UtilsContext = this;
        if (position > target.length) {
            /* 超出目标字符串的长度 */
            return false;
        }
        if (position !== 0) {
            target = target.slice(position, target.length);
        }
        let searchStringRegexp = searchString;
        if (typeof searchString === "string") {
            searchStringRegexp = new RegExp(`^${searchString}`);
        }
        else if (Array.isArray(searchString)) {
            let flag = false;
            for (const searcStr of searchString) {
                if (!UtilsContext.startsWith(target, searcStr, position)) {
                    flag = true;
                    break;
                }
            }
            return flag;
        }
        return Boolean(target.match(searchStringRegexp));
    }
    stringTitleToLowerCase(targetString, otherStrToUpperCase = false) {
        let newTargetString = targetString.slice(0, 1).toLowerCase();
        if (otherStrToUpperCase) {
            newTargetString = newTargetString + targetString.slice(1).toUpperCase();
        }
        else {
            newTargetString = newTargetString + targetString.slice(1);
        }
        return newTargetString;
    }
    toJSON(data, errorCallBack) {
        let UtilsContext = this;
        let result = {};
        if (typeof data === "object") {
            return data;
        }
        UtilsContext.tryCatch()
            .config({ log: false })
            .error((error) => {
            UtilsContext.tryCatch()
                .error(() => {
                try {
                    result = UtilsContext.windowApi.window.eval("(" + data + ")");
                }
                catch (error2) {
                    if (typeof errorCallBack === "function") {
                        errorCallBack(error2);
                    }
                }
            })
                .run(() => {
                if (data &&
                    /^[\],:{}\s]*$/.test(data
                        .replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@")
                        .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]")
                        .replace(/(?:^|:|,)(?:\s*\[)+/g, ""))) {
                    result = new Function("return " + data)();
                }
                else {
                    if (typeof errorCallBack === "function") {
                        errorCallBack(new Error("target is not a JSON"));
                    }
                }
            });
        })
            .run(() => {
            data = data.trim();
            result = JSON.parse(data);
        });
        return result;
    }
    toSearchParamsStr(obj, addPrefix) {
        let UtilsContext = this;
        let searhParamsStr = "";
        if (Array.isArray(obj)) {
            obj.forEach((item) => {
                if (searhParamsStr === "") {
                    searhParamsStr += UtilsContext.toSearchParamsStr(item);
                }
                else {
                    searhParamsStr += "&" + UtilsContext.toSearchParamsStr(item);
                }
            });
        }
        else {
            searhParamsStr = new URLSearchParams(Object.entries(obj)).toString();
        }
        if (addPrefix && !searhParamsStr.startsWith("?")) {
            searhParamsStr = "?" + searhParamsStr;
        }
        return searhParamsStr;
    }
    /**
     * 将UrlSearchParams格式的字符串转为对象
     */
    searchParamStrToObj(searhParamsStr) {
        if (typeof searhParamsStr !== "string") {
            // @ts-ignore
            return {};
        }
        // @ts-ignore
        return Object.fromEntries(new URLSearchParams(searhParamsStr));
    }
    /**
     * 提供一个封装了 try-catch 的函数，可以执行传入的函数并捕获其可能抛出的错误，并通过传入的错误处理函数进行处理。
     * @example
     * Utils.tryCatch().error().run(()=>{console.log(1)});
     * > 1
     * @example
     * Utils.tryCatch().config({log:true}).error((error)=>{console.log(error)}).run(()=>{throw new Error('测试错误')});
     * > ()=>{throw new Error('测试错误')}出现错误
     */
    tryCatch = TryCatch;
    uniqueArray(uniqueArrayData = [], compareArrayData, compareFun = (item, item2) => {
        return item === item2;
    }) {
        if (typeof compareArrayData === "function") {
            const compareFn = compareArrayData;
            const seen = new Set();
            const result = [];
            for (const item of uniqueArrayData) {
                // 使用compareFn函数来获取当前对象的唯一标识
                const identfier = compareFn(item);
                // 如果Set中还没有这个标识，则添加到结果数组中，并将其标识存入Set
                if (!seen.has(identfier)) {
                    seen.add(identfier);
                    result.push(item);
                }
            }
            return result;
        }
        else {
            return Array.from(uniqueArrayData).filter((item) => !Array.from(compareArrayData).some(function (item2) {
                return compareFun(item, item2);
            }));
        }
    }
    waitArrayLoopToEnd(data, handleFunc) {
        let UtilsContext = this;
        if (typeof handleFunc !== "function" && typeof handleFunc !== "string") {
            throw new Error("Utils.waitArrayLoopToEnd 参数 handleDataFunction 必须为 function|string 类型");
        }
        return Promise.all(Array.from(data).map(async (item, index) => {
            await UtilsContext.tryCatch(index, item).run(handleFunc);
        }));
    }
    wait(checkFn, timeout, parent) {
        const UtilsContext = this;
        let __timeout__ = typeof timeout === "number" ? timeout : 0;
        return new Promise((resolve) => {
            let observer = UtilsContext.mutationObserver(parent || UtilsContext.windowApi.document, {
                config: {
                    subtree: true,
                    childList: true,
                    attributes: true,
                },
                immediate: true,
                callback(mutations, __observer__) {
                    let result = checkFn();
                    if (result.success) {
                        // 取消观察器
                        if (typeof __observer__?.disconnect === "function") {
                            __observer__.disconnect();
                        }
                        resolve(result.data);
                    }
                },
            });
            if (__timeout__ > 0) {
                setTimeout(() => {
                    // 取消观察器
                    if (typeof observer?.disconnect === "function") {
                        observer.disconnect();
                    }
                    resolve(null);
                }, __timeout__);
            }
        });
    }
    waitNode(...args) {
        // 过滤掉undefined
        args = args.filter((arg) => arg !== void 0);
        let UtilsContext = this;
        // 选择器
        let selector = args[0];
        // 父元素（监听的元素）
        let parent = UtilsContext.windowApi.document;
        // 超时时间
        let timeout = 0;
        if (typeof args[0] !== "string" &&
            !Array.isArray(args[0]) &&
            typeof args[0] !== "function") {
            throw new TypeError("Utils.waitNode 第一个参数必须是string|string[]|Function");
        }
        if (args.length === 1) {
            // 上面已做处理
        }
        else if (args.length === 2) {
            let secondParam = args[1];
            if (typeof secondParam === "number") {
                // "div",10000
                timeout = secondParam;
            }
            else if (typeof secondParam === "object" &&
                secondParam instanceof Node) {
                // "div",document
                parent = secondParam;
            }
            else {
                throw new TypeError("Utils.waitNode 第二个参数必须是number|Node");
            }
        }
        else if (args.length === 3) {
            // "div",document,10000
            // 第二个参数，parent
            let secondParam = args[1];
            // 第三个参数，timeout
            let thirdParam = args[2];
            if (typeof secondParam === "object" && secondParam instanceof Node) {
                parent = secondParam;
                if (typeof thirdParam === "number") {
                    timeout = thirdParam;
                }
                else {
                    throw new TypeError("Utils.waitNode 第三个参数必须是number");
                }
            }
            else {
                throw new TypeError("Utils.waitNode 第二个参数必须是Node");
            }
        }
        else {
            throw new TypeError("Utils.waitNode 参数个数错误");
        }
        function getNode() {
            if (Array.isArray(selector)) {
                let result = [];
                for (let index = 0; index < selector.length; index++) {
                    let node = parent.querySelector(selector[index]);
                    if (node) {
                        result.push(node);
                    }
                }
                if (result.length === selector.length) {
                    return result;
                }
            }
            else if (typeof selector === "function") {
                return selector();
            }
            else {
                return parent.querySelector(selector);
            }
        }
        return UtilsContext.wait(() => {
            let node = getNode();
            if (node) {
                return {
                    success: true,
                    data: node,
                };
            }
            else {
                return {
                    success: false,
                    data: node,
                };
            }
        }, timeout, parent);
    }
    waitAnyNode(...args) {
        // 过滤掉undefined
        args = args.filter((arg) => arg !== void 0);
        let UtilsContext = this;
        // 选择器
        let selectorList = args[0];
        // 父元素（监听的元素）
        let parent = UtilsContext.windowApi.document;
        // 超时时间
        let timeout = 0;
        if (typeof args[0] !== "object" && !Array.isArray(args[0])) {
            throw new TypeError("Utils.waitAnyNode 第一个参数必须是string[]");
        }
        if (args.length === 1) {
            // 上面已做处理
        }
        else if (args.length === 2) {
            let secondParam = args[1];
            if (typeof secondParam === "number") {
                // "div",10000
                timeout = secondParam;
            }
            else if (typeof secondParam === "object" &&
                secondParam instanceof Node) {
                // "div",document
                parent = secondParam;
            }
            else {
                throw new TypeError("Utils.waitAnyNode 第二个参数必须是number|Node");
            }
        }
        else if (args.length === 3) {
            // "div",document,10000
            // 第二个参数，parent
            let secondParam = args[1];
            // 第三个参数，timeout
            let thirdParam = args[2];
            if (typeof secondParam === "object" && secondParam instanceof Node) {
                parent = secondParam;
                if (typeof thirdParam === "number") {
                    timeout = thirdParam;
                }
                else {
                    throw new TypeError("Utils.waitAnyNode 第三个参数必须是number");
                }
            }
            else {
                throw new TypeError("Utils.waitAnyNode 第二个参数必须是Node");
            }
        }
        else {
            throw new TypeError("Utils.waitAnyNode 参数个数错误");
        }
        let promiseList = selectorList.map((selector) => {
            return UtilsContext.waitNode(selector, parent, timeout);
        });
        return Promise.any(promiseList);
    }
    waitNodeList(...args) {
        // 过滤掉undefined
        args = args.filter((arg) => arg !== void 0);
        let UtilsContext = this;
        // 选择器数组
        let selector = args[0];
        // 父元素（监听的元素）
        let parent = UtilsContext.windowApi.document;
        // 超时时间
        let timeout = 0;
        if (typeof args[0] !== "string" && !Array.isArray(args[0])) {
            throw new TypeError("Utils.waitNodeList 第一个参数必须是string|string[]");
        }
        if (args.length === 1) {
            // 上面已做处理
        }
        else if (args.length === 2) {
            let secondParam = args[1];
            if (typeof secondParam === "number") {
                // "div",10000
                timeout = secondParam;
            }
            else if (typeof secondParam === "object" &&
                secondParam instanceof Node) {
                // "div",document
                parent = secondParam;
            }
            else {
                throw new TypeError("Utils.waitNodeList 第二个参数必须是number|Node");
            }
        }
        else if (args.length === 3) {
            // "div",document,10000
            // 第二个参数，parent
            let secondParam = args[1];
            // 第三个参数，timeout
            let thirdParam = args[2];
            if (typeof secondParam === "object" && secondParam instanceof Node) {
                parent = secondParam;
                if (typeof thirdParam === "number") {
                    timeout = thirdParam;
                }
                else {
                    throw new TypeError("Utils.waitNodeList 第三个参数必须是number");
                }
            }
            else {
                throw new TypeError("Utils.waitNodeList 第二个参数必须是Node");
            }
        }
        else {
            throw new TypeError("Utils.waitNodeList 参数个数错误");
        }
        function getNodeList() {
            if (Array.isArray(selector)) {
                let result = [];
                for (let index = 0; index < selector.length; index++) {
                    let nodeList = parent.querySelectorAll(selector[index]);
                    if (nodeList.length) {
                        result.push(nodeList);
                    }
                }
                if (result.length === selector.length) {
                    return result;
                }
            }
            else {
                let nodeList = parent.querySelectorAll(selector);
                if (nodeList.length) {
                    return nodeList;
                }
            }
        }
        return UtilsContext.wait(() => {
            let node = getNodeList();
            if (node) {
                return {
                    success: true,
                    data: node,
                };
            }
            else {
                return {
                    success: false,
                    data: node,
                };
            }
        }, timeout, parent);
    }
    waitAnyNodeList(...args) {
        // 过滤掉undefined
        args = args.filter((arg) => arg !== void 0);
        let UtilsContext = this;
        // 选择器数组
        let selectorList = args[0];
        // 父元素（监听的元素）
        let parent = UtilsContext.windowApi.document;
        // 超时时间
        let timeout = 0;
        if (!Array.isArray(args[0])) {
            throw new TypeError("Utils.waitAnyNodeList 第一个参数必须是string[]");
        }
        if (args.length === 1) {
            // 上面已做处理
        }
        else if (args.length === 2) {
            let secondParam = args[1];
            if (typeof secondParam === "number") {
                // "div",10000
                timeout = secondParam;
            }
            else if (typeof secondParam === "object" &&
                secondParam instanceof Node) {
                // "div",document
                parent = secondParam;
            }
            else {
                throw new TypeError("Utils.waitAnyNodeList 第二个参数必须是number|Node");
            }
        }
        else if (args.length === 3) {
            // "div",document,10000
            // 第二个参数，parent
            let secondParam = args[1];
            // 第三个参数，timeout
            let thirdParam = args[2];
            if (typeof secondParam === "object" && secondParam instanceof Node) {
                parent = secondParam;
                if (typeof thirdParam === "number") {
                    timeout = thirdParam;
                }
                else {
                    throw new TypeError("Utils.waitAnyNodeList 第三个参数必须是number");
                }
            }
            else {
                throw new TypeError("Utils.waitAnyNodeList 第二个参数必须是Node");
            }
        }
        else {
            throw new TypeError("Utils.waitAnyNodeList 参数个数错误");
        }
        let promiseList = selectorList.map((selector) => {
            return UtilsContext.waitNodeList(selector, parent, timeout);
        });
        return Promise.any(promiseList);
    }
    waitProperty(checkObj, checkPropertyName) {
        return new Promise((resolve) => {
            let obj = checkObj;
            if (typeof checkObj === "function") {
                obj = checkObj();
            }
            if (Reflect.has(obj, checkPropertyName)) {
                resolve(obj[checkPropertyName]);
            }
            else {
                Object.defineProperty(obj, checkPropertyName, {
                    set: function (value) {
                        try {
                            resolve(value);
                        }
                        catch (error) {
                            console.error("Error setting property:", error);
                        }
                    },
                });
            }
        });
    }
    waitPropertyByInterval(checkObj, checkPropertyName, intervalTimer = 250, maxTime = -1) {
        if (checkObj == null) {
            throw new TypeError("checkObj 不能为空对象 ");
        }
        let isResolve = false;
        return new Promise((resolve, reject) => {
            let interval = setInterval(() => {
                let obj = checkObj;
                if (typeof checkObj === "function") {
                    obj = checkObj();
                }
                if (typeof obj !== "object") {
                    return;
                }
                if (obj == null) {
                    return;
                }
                if ((typeof checkPropertyName === "function" && checkPropertyName(obj)) ||
                    Reflect.has(obj, checkPropertyName)) {
                    isResolve = true;
                    clearInterval(interval);
                    resolve(obj[checkPropertyName]);
                }
            }, intervalTimer);
            if (maxTime !== -1) {
                setTimeout(() => {
                    if (!isResolve) {
                        clearInterval(interval);
                        reject();
                    }
                }, maxTime);
            }
        });
    }
    async waitVueByInterval(element, propertyName, timer = 250, maxTime = -1, vueName = "__vue__") {
        if (element == null) {
            throw new Error("Utils.waitVueByInterval 参数element 不能为空");
        }
        let flag = false;
        let UtilsContext = this;
        try {
            await UtilsContext.waitPropertyByInterval(element, function (targetElement) {
                if (targetElement == null) {
                    return false;
                }
                if (!(vueName in targetElement)) {
                    return false;
                }
                if (propertyName == null) {
                    return true;
                }
                let vueObject = targetElement[vueName];
                if (typeof propertyName === "string") {
                    if (propertyName in vueObject) {
                        flag = true;
                        return true;
                    }
                }
                else {
                    /* Function */
                    if (propertyName(vueObject)) {
                        flag = true;
                        return true;
                    }
                }
                return false;
            }, timer, maxTime);
        }
        catch (error) {
            return flag;
        }
        return flag;
    }
    watchObject(target, propertyName, getCallBack, setCallBack) {
        if (typeof getCallBack !== "function" &&
            typeof setCallBack !== "function") {
            return;
        }
        if (typeof getCallBack === "function") {
            Object.defineProperty(target, propertyName, {
                get() {
                    if (typeof getCallBack === "function") {
                        return getCallBack(target[propertyName]);
                    }
                    else {
                        return target[propertyName];
                    }
                },
            });
        }
        else if (typeof setCallBack === "function") {
            Object.defineProperty(target, propertyName, {
                set(value) {
                    if (typeof setCallBack === "function") {
                        setCallBack(value);
                    }
                },
            });
        }
        else {
            Object.defineProperty(target, propertyName, {
                get() {
                    if (typeof getCallBack === "function") {
                        return getCallBack(target[propertyName]);
                    }
                    else {
                        return target[propertyName];
                    }
                },
                set(value) {
                    if (typeof setCallBack === "function") {
                        setCallBack(value);
                    }
                },
            });
        }
    }
    /**
     * 深度获取对象属性
     * @param target 待获取的对象
     * @param handler 获取属性的回调
     */
    queryProperty(target, handler) {
        if (target == null) {
            return;
        }
        let handleResult = handler(target);
        if (handleResult &&
            typeof handleResult.isFind === "boolean" &&
            handleResult.isFind) {
            return handleResult.data;
        }
        return this.queryProperty(handleResult.data, handler);
    }
    /**
     * 创建一个新的Utils实例
     * @param option
     * @returns
     */
    createUtils(option) {
        return new Utils(option);
    }
    /**
     * 将对象转换为FormData
     * @param data 待转换的对象
     * @param isEncode 是否对值为string进行编码转换(encodeURIComponent)，默认false
     * @param valueAutoParseToStr 是否对值强制使用JSON.stringify()转换，默认false
     * @example
     * Utils.toFormData({
     * 	test: "1",
     *  666: 666,
     * })
     */
    toFormData(data, isEncode = false, valueAutoParseToStr = false) {
        const formData = new FormData();
        Object.keys(data).forEach((key) => {
            let value = data[key];
            if (valueAutoParseToStr) {
                value = JSON.stringify(value);
            }
            if (typeof value === "number") {
                value = value.toString();
            }
            if (isEncode && typeof value === "string") {
                value = encodeURIComponent(value);
            }
            if (value instanceof File) {
                formData.append(key, value, value.name);
            }
            else {
                formData.append(key, value);
            }
        });
        return formData;
    }
    /**
     * 将链接转为URL对象，自动补充URL的protocol或者origin
     * @param text 需要转换的链接字符串
     * @example
     * Utils.toUrl("//www.baidu.com/s?word=666");
     * Utils.toUrl("/s?word=666");
     */
    toUrl(text) {
        if (typeof text !== "string") {
            throw new TypeError("toUrl: text must be string");
        }
        text = text.trim();
        if (text === "") {
            throw new TypeError("toUrl: text must not be empty");
        }
        if (text.startsWith("//")) {
            /* //www.baidu.com/xxxxxxx */
            /* 没有protocol，加上 */
            text = this.windowApi.globalThis.location.protocol + text;
        }
        else if (text.startsWith("/")) {
            /* /xxx/info?xxx=xxx */
            /* 没有Origin，加上 */
            text = this.windowApi.globalThis.location.origin + text;
        }
        return new URL(text);
    }
    /**
     * 生成uuid
     * @example
     * Utils.generateUUID()
     */
    generateUUID = GenerateUUID;
    /**
     * 自定义的动态响应对象
     * @example
     * let vue = new Utils.Vue();
     * let reactive = new vue.reactive({});
     * vue.watch(()=>reactive["name"], (newValue, oldValue)=>{
     *     console.log("newValue ==> " + newValue);
     *     console.log("oldValue ==> " + oldValue);
     * })
     * vue["name"] = "测试";
     * > "测试"
     */
    Vue = Vue;
    ModuleRaid = ModuleRaid;
}
let utils = new Utils();
export { utils as Utils };
